<script lang="ts">
  /**
   * Іконка зі спрайту (див. IconSprite.svelte).
   *
   *   <Icon name="house" />              — стандартний розмір, 1.15em
   *   <Icon name="heart" size="lg" />    — 22px
   *   <Icon name="heart" filled />       — залита (улюблене, активний стан)
   *
   * Розміри й товщина обведення — з мокапу: stroke-width 1.75 замість
   * дефолтних Lucide 2.0, бо на дрібних розмірах двійка виглядає грубо.
   */
  import type { IconName } from '../lib/icons';

  interface Props {
    name: IconName;
    /** nav — 19px (нижня навігація) · lg — 22px · xl — 30px · xs — 12px.
     *  Без розміру іконка масштабується від розміру тексту (1.15em). */
    size?: 'nav' | 'lg' | 'xl' | 'xs';
    /** Заливка замість обведення — для «улюбленого» й активних станів. */
    filled?: boolean;
    /** Підпис для читача екрана. Без нього іконка суто декоративна
     *  (aria-hidden) — саме так і має бути поруч із текстом. */
    label?: string;
  }
  let { name, size, filled = false, label }: Props = $props();
</script>

<svg
  class="ic"
  class:ic-nav={size === 'nav'}
  class:ic-lg={size === 'lg'}
  class:ic-xl={size === 'xl'}
  class:ic-xs={size === 'xs'}
  class:ic-fill={filled}
  role={label ? 'img' : undefined}
  aria-label={label}
  aria-hidden={label ? undefined : true}
>
  <use href="#i-{name}" />
</svg>
